import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

import { SharedModule } from '@shared/shared.module';

import { AcademyLinkPipe } from './academy-link.pipe';
import { AcademyComponent } from './academy.component';

@NgModule({
  declarations: [AcademyComponent, AcademyLinkPipe],
  imports: [SharedModule, TranslateModule.forChild()],
  exports: [AcademyComponent],
  providers: [],
})
export class AcademyModule {}
